module.exports = __webpack_public_path__ + "static/media/bulbguardcam-1.d82d0cd6.jpg";